import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useBuildingReferenceSearch } from "features/global-search/api/useBuildingReferenceSearch"
import {
  BuildingReferenceOptionsGroup,
  GlobalSearchResultType
} from "features/global-search/types/GlobalSearch"

interface UseBuildingReferenceOptionsGroupArgs {
  searchTerm: string | null
  variantKeys?: string[] | null
}

export function useBuildingReferenceOptionsGroup({
  searchTerm,
  variantKeys
}: UseBuildingReferenceOptionsGroupArgs): {
  buildingReferenceOptions: BuildingReferenceOptionsGroup | null
  isLoading: boolean
} {
  const { t } = useTranslation()
  const { results: buildingReferences, isLoading } = useBuildingReferenceSearch(
    {
      searchTerm,
      variantKeys
    }
  )

  const buildingReferenceOptions =
    useMemo<BuildingReferenceOptionsGroup | null>(() => {
      if (buildingReferences.length === 0) return null
      return {
        type: GlobalSearchResultType.BUILDING_REFERENCE,
        label: t("BuildingReference.References"),
        options: buildingReferences.map(buildingReference => ({
          id: buildingReference.id,
          value: buildingReference.id,
          label: buildingReference.title,
          type: GlobalSearchResultType.BUILDING_REFERENCE,
          data: {
            obj: buildingReference.obj,
            matchInfo: buildingReference.matchInfo
          }
        }))
      }
    }, [buildingReferences, t])

  return { buildingReferenceOptions, isLoading }
}
